/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
require("./src/style/global.css")
require("prismjs/themes/prism.css")
// require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require(`katex/dist/katex.min.css`)
